export type OpenedPreset = 'today' | 'yesterday' | 'last7' | 'last30';

export interface DateRange {
  after: string; // YYYY-MM-DD, or '' for unset
  before: string;
}

export const OPENED_PRESETS: { key: OpenedPreset; label: string }[] = [
  { key: 'today', label: 'Today' },
  { key: 'yesterday', label: 'Yesterday' },
  { key: 'last7', label: 'Last 7 days' },
  { key: 'last30', label: 'Last 30 days' },
];

function toIsoDate(d: Date): string {
  const y = d.getFullYear();
  const m = String(d.getMonth() + 1).padStart(2, '0');
  const day = String(d.getDate()).padStart(2, '0');
  return `${y}-${m}-${day}`;
}

function addDays(d: Date, n: number): Date {
  const r = new Date(d);
  r.setDate(r.getDate() + n);
  return r;
}

/** Inclusive day-granularity range for a preset, relative to `today`. */
export function presetRange(key: OpenedPreset, today: Date): DateRange {
  const to = toIsoDate(today);
  switch (key) {
    case 'today':
      return { after: to, before: to };
    case 'yesterday': {
      const y = toIsoDate(addDays(today, -1));
      return { after: y, before: y };
    }
    case 'last7':
      return { after: toIsoDate(addDays(today, -6)), before: to };
    case 'last30':
      return { after: toIsoDate(addDays(today, -29)), before: to };
  }
}

/** Human label for the current range: a preset name, 'Any date', or 'Custom'. */
export function rangeLabel(after: string, before: string, today: Date): string {
  if (!after && !before) return 'Any date';
  for (const { key, label } of OPENED_PRESETS) {
    const r = presetRange(key, today);
    if (r.after === after && r.before === before) return label;
  }
  return 'Custom';
}
